<template>
  <vs-popup id="popup-tip" class="checkout-popup-tip" title="Add Tip" :active.sync="popupTip.isOpen">
      <div class="py-3">
        <div class="flex mb-5" style="align-items: flex-end">
          <div class="w-2/3">
            <div class="mr-6">
              <label class="text-sm">Total Amount
                <span v-if="is_dollar">(1%)</span>
                <span v-if="!is_dollar">($1)</span>
              </label>
              <vs-input icon="attach_money" class="w-full" v-model="input_tip" v-if="is_dollar" placeholder="0.00" v-on:keypress="isNumber($event)"/>
              <vs-input icon="%" class="w-full icon-percent" v-model="input_tip" v-if="!is_dollar" placeholder="0.00" v-on:keypress="isNumber($event)"/>
            </div>
          </div>
          <div class="w-1/3 ml-auto">
            <div class="can-toggle">
              <input id="a" type="checkbox" v-model="is_dollar" @click="changeStatus">
              <label for="a">
                <div class="can-toggle__switch" data-checked="$" data-unchecked="%"></div>
              </label>
            </div>
          </div>
        </div>
        <div class="mb-base">
          <label class="text-sm">Staff</label>
          <v-select @input="selectId($event)" class="w-full"></v-select>
        </div>
        <btn-custom>Save</btn-custom>
      </div>
  </vs-popup>
</template>

<script>
import vSelect from 'vue-select'
export default {
  name: 'vs-popup-tip',
  components: {
    'v-select': vSelect,
  },
  props:{
    popupTip: {
      type: Object,
    }
  },
  data() {
    return {
      is_dollar: true,
      input_tip: ''
    }
  },
  methods: {
    changeStatus() {
      console.log(this.is_dollar)
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && this.input_tip.indexOf(".") != -1)) {
          evt.preventDefault();
      } else {
          return true;
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables";
.con-vs-popup {
        &.checkout-popup-tip {
            z-index: 90000 !important;
           .vs-popup {
             width: 434px;
             .vs-popup--content {
               margin: 0;
               width: 100%;
             }
           }
        }
}

#popup-tip {
  .input-span-placeholder {
    top: 0.2px;
    left: 6px;
    font-size: 14px;
  }
  .vs-input--icon {
      top: 11px;
  }
  .icon-percent {
    &:before {
      content: ''
    }
    .vs-input--icon {
      font-size: 12px;
      padding-right: 4px;
      padding-left: 4px;
    }
  }
  .vs-input--input.hasIcon {
    padding: 0.55rem 1rem 0.55rem 3rem;
  }
  @mixin can-toggle-branding(
  $can-toggle-off-color: #fff, 
  $can-toggle-on-color: #fff,
  $can-toggle-inactive-text: #000,
  $can-toggle-transition: cubic-bezier(0,1,0.5,1)
) {
  
  input[type="checkbox"] {
    &[disabled] ~ label {
      color: rgba($can-toggle-off-color, 0.5);
      // background-color: #ddd;
    }
    
    &:focus ~ label, &:hover ~ label {
      .can-toggle__switch {
        background-color: #ddd;
        &:after { color: darken($can-toggle-off-color, 10%); }
      }
    }
    &:hover ~label { color: darken($can-toggle-off-color, 5%); }
    &:checked {
      ~ label {
        &:hover { color: darken($can-toggle-on-color, 3%); }
        
        .can-toggle__switch {
          // background-color: lighten($can-toggle-on-color, 5%);
          background: #ddd;
          &:after { color: darken($can-toggle-on-color, 5%); }
        }
      }
      
      &:focus, &:hover {
        ~ label {
          .can-toggle__switch {
            // background-color: $can-toggle-on-color;
            background: #ddd;
            &:after { color: darken($can-toggle-on-color, 10%); }
          }
        } 
      }
    }
  }
  
  label {
    
    // .can-toggle__label-text { flex: 1; }
    
    .can-toggle__switch {
      transition: background-color 0.3s $can-toggle-transition;
      // background: lighten($can-toggle-off-color, 5%);
      background: #ddd;
      &:before { color: $can-toggle-inactive-text; }
      &:after {
        // Autoprefixer choked here, so making the prefixes explicit
        -webkit-transition: -webkit-transform 0.3s $can-toggle-transition;
        transition: transform 0.3s $can-toggle-transition;
        color: $can-toggle-off-color; 
      }
    }
    
  }
}

@mixin can-toggle-appearance 
( 
  $can-toggle-width: 134px,
  $can-toggle-height: 36px,
  $can-toggle-border-radius: 4px,
  $can-toggle-offset: 2px,
  $can-toggle-label-font-size: 14px,
  $can-toggle-switch-font-size: 12px,
  // $can-toggle-shadow: 0 3px 3px rgba(black, 0.4)
  $can-toggle-shadow: 0 3px 3px #ddd
){
  $can-toggle-switch-width: $can-toggle-width/2;
  
  input[type="checkbox"] {

    &:focus ~ label, &:hover ~ label {
      .can-toggle__switch {
        &:after { box-shadow: $can-toggle-shadow; } 
      }
    }
    
    &:checked {
      ~ label {
        .can-toggle__switch {
          &:after { transform: translate3d($can-toggle-width - ($can-toggle-switch-width + $can-toggle-offset),0,0); }  
        }
      }
      &:focus, &:hover {
        ~ label {
          .can-toggle__switch { &:after { box-shadow: $can-toggle-shadow; } }
        } 
      }
    }
  }
  
  label {
    font-size: $can-toggle-label-font-size;
    
    .can-toggle__switch {
      height: $can-toggle-height;
      flex: 0 0 $can-toggle-width;
      border-radius: $can-toggle-border-radius;
      
      &:before {
        left: $can-toggle-width/2;
        font-size: $can-toggle-switch-font-size; 
        line-height: $can-toggle-height;
        width: $can-toggle-width/2;
        padding: 0 12px;
      }
      
      &:after {
        top: $can-toggle-offset; left: $can-toggle-offset;
        border-radius: $can-toggle-border-radius/2;
        width: $can-toggle-switch-width - $can-toggle-offset; 
        line-height: $can-toggle-height - ($can-toggle-offset*2);
        font-size: $can-toggle-switch-font-size;
      }
      
      &:hover {
        &:after { box-shadow: $can-toggle-shadow; }
      }
    } 
  }
}



.can-toggle {
  position: relative;
  *, *:before, *:after { box-sizing: border-box; }
  //overflow: hidden;
  
  input[type="checkbox"] {
    opacity: 0;
    position: absolute;
    top: 0; left: 0;
    
    &[disabled] ~ label {
      pointer-events: none;
      .can-toggle__switch { opacity: 0.4; }
    }
    
    &:checked {
      ~ label {
        
        .can-toggle__switch {
          
          &:before {
            content: attr(data-unchecked);
            left: 0;
          }
        
          &:after {
            content: attr(data-checked);
          }  
        }
      }
      
      &:focus, &:hover {
        ~ label {
        } 
      }
    }
  }
  
  label {
    user-select: none;
    position: relative;
    display: flex;
    align-items: center;
    
    .can-toggle__label-text { 
      flex: 1;
      padding-left: 32px;
    }
    
    .can-toggle__switch {
      position: relative;
      // box-shadow: 0 0 1px 1px #ddd;      
      &:before {
        content: attr(data-checked);
        position: absolute;
        top: 0;
        text-transform: uppercase;
        text-align: center;
      }
      
      &:after {
        content: attr(data-unchecked);
        position: absolute;
        z-index: 5;
        text-transform: uppercase;
        text-align: center;
        background: $primary;
        color: #fff;
        transform: translate3d(0,0,0);
      }

    }
    
  }
  
  // Default values for .can-toggle class
  @include can-toggle-branding; 
  @include can-toggle-appearance; 
  
  // Create toggles of different sizes by overriding the can-toggle-appearance mixin defaults
  &.can-toggle--size-small {
    @include can-toggle-appearance
    (
      90px, // Toggle width
      28px,  // Toggle height
      2px,   // Toggle border radius
      1px,   // Offset (distance btw switch and box)
      13px,  // Label font size
      10px,  // Switch font size
      0 2px 2px rgba(black, 0.4) // Switch shadow on hover/focus
    ); 
  }
  
  &.can-toggle--size-large {
    @include can-toggle-appearance
    (
      160px, // Toggle width
      50px,  // Toggle height
      4px,   // Toggle border radius
      2px,   // Offset (distance btw switch and box)
      14px,  // Label font size
      14px,  // Switch font size
      0 4px 4px rgba(black, 0.4) // Switch shadow on hover/focus
    ); 
  }
  
  // Or re-brand the toggle for different applications
  &.demo-rebrand-1 {
    @include can-toggle-branding
    (
      #b53e74,  // Off state color
      #3d9c72,  // On state color
      rgba(white, 0.6),  // Off state text color
      ease-in-out  // Transition timing function
    ); 
  }
  
  &.demo-rebrand-2 {
    @include can-toggle-branding
    (
      #444,  // Off state color
      #69be28,  // On state color
      rgba(white, 0.7),  // Off state text color
      cubic-bezier(0.860, 0.000, 0.070, 1.000)  // Transition timing function
    );
    @include can-toggle-appearance
    (
      120px, // Toggle width
      60px,  // Toggle height
      60px,   // Toggle border radius
      2px,   // Offset (distance btw switch and box)
      13px,  // Label font size
      13px,  // Switch font size
      0 4px 4px rgba(black, 0.4) // Switch shadow on hover/focus
    ); 
  }
  
}
}
</style>
